export default {
  // on: true,
  // cache: true,
  // auth: true,
  // intercept: false,
} as TCommon.RouteConfig
